<template>
  <div class="travellingTrader common_group">
    <div class="title clear">
      <img src="@/assets/images/userIcon.png">
      <span>{{ $t('approvalCenter.PCU') }}</span>
      <div class="buttonBar">
        <div class="custom">
          <span @click="companyQueryBtn"><img src="@/assets/images/tinyanchalogo.png"><span>{{ $t('approvalCenter.tyc')
          }}</span></span>
          <span @click="preview"><img src="@/assets/images/zhinanzhen.png"><span>{{ $t('approvalCenter.ceog')
          }}</span></span>
        </div>
        <el-button plain @click="addTrader">{{ $t('btn.New') }}</el-button>
        <el-button plain @click="importTrader">{{ $t('newApp.Customers.ei') }}</el-button>
        <el-button plain @click="exportTrader">{{ $t('newApp.Customers.eu') }}</el-button>
        <el-button plain @click="upDateCrm">{{ $t('approvalCenter.SyncCRM') }}</el-button>
        <el-button plain @click="statusChangeBtn">{{ $t('btn.BS') }}</el-button>
        <el-button plain @click="batchDeleteBtn">{{ $t('btn.BatchDel') }} </el-button>
        <el-button plain @click="exportBtn">{{ $t('btn.EC') }}</el-button>
      </div>
    </div>
    <commonTable
      ref="statisticsTable"
      style="margin-bottom:20px"
      v-show="!$store.state.useSimplifiedForm"
    />
    <commonTable
      ref="travellingTraderTable"
      @handleTableList="gethandleTableList"
      :data-filter-method="dataFilterMethod"
      :cell-class-name="traderCellClassName"
    />
    <addTraderDialog
      :saler-id="echoData ? echoData.marketActivity.salerId : ''"
      :row-data="rowData"
      :add-trader-dialog-visible="addTraderDialogVisible"
      @addSuccessHandle="addSuccessHandle"
      @dialogCloseHandle="addTraderDialogCloseHandle"
    />
    <importTraderDialog
      :import-trader-visible="importTraderVisible"
      @dialogCloseHandle="importTraderDialogCloseHandle"
      @dialogSuccessHandle="importTraderDialogCloseHandle"
    />
    <exportTraderDialog
      :export-trader-visible="exportTraderVisible"
      @dialogCloseHandle="exportTraderDialogCloseHandle"
    />
  </div>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addTraderDialog from '../../component/activityDetails/travellingTrader/addTraderDialog';
import importTraderDialog from '../../component/activityDetails/travellingTrader/importTraderDialog';
import exportTraderDialog from '../../component/activityDetails/travellingTrader/exportTraderDialog';
import { travellingTrader } from '../../service';
import { getTicket } from '@/utils/utils';
import axios from 'axios';
import { commonServer } from '@/API/home';
import requestBaseUrl from '@/API/request/baseUrl';
export default {
  data () {
    return {
      addTraderDialogVisible: false,
      importTraderVisible: false,
      exportTraderVisible: false,
      rowData: {},
      dataFilterMethod: null,
      contactsNeedFlag: false,
      widthAutoFlag: false,
      statisticsTable: [],
      clickStatus: false
    };
  },
  props: {
    echoData: {
      type: Object,
      default: null
    }
  },
  components: {
    commonTable,
    addTraderDialog,
    importTraderDialog,
    exportTraderDialog
  },
  methods: {
    preview () {
      commonServer.getPreviewUrl('15125103555334144').then(res => {
        if (res.status === '200') {
          let pdfPath = encodeURIComponent(res.data);
          let previewURL = `/static/pdf/web/viewer.html?file=${pdfPath}`;
          window.open(previewURL, '_blank');
        }
      });
    },
    companyQueryBtn () {
      window.open(`https://www.tianyancha.com`);
    },
    exportBtn () {
      let checkedData = this.$refs.travellingTraderTable.getCheckboxRecords();
      const data = {
        idList: checkedData.map(item => {
          return item.id;
        }),
        activityCode: this.$route.query.activityCode
      };
      axios({
        method: 'post',
        headers: {
          sysId: window._env_.VUE_APP_SYSID,
          union_session_ticket: getTicket()
        },
        withCredentials: true,
        url: `${requestBaseUrl}/customer/customerExcel`,
        responseType: 'blob',
        data: data
      }).then(response => {
        let date = new Date().format('yyyyMMddhhmmss');
        // let fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1]);
        let fileName = this.$t('eventList.CustomerInfo') + `${date}`;
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
        link.target = '_blank';
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
      // if (checkedData.length > 0) {
      // } else {
      //   this.$message.error(this.$t('eventList.Psaec'));
      // }
    },
    addTrader () {
      this.addTraderDialogVisible = true;
    },
    addTraderDialogCloseHandle () {
      this.addTraderDialogVisible = false;
      this.rowData = {};
    },
    addSuccessHandle () {
      this.loadTable();
      this.rowData = {};
      this.addTraderDialogVisible = false;
    },
    importTrader () {
      this.importTraderVisible = true;
    },
    importTraderDialogCloseHandle () {
      this.loadTable();
      this.importTraderVisible = false;
    },
    exportTrader () {
      this.exportTraderVisible = true;
    },
    exportTraderDialogCloseHandle () {
      this.loadTable();
      this.exportTraderVisible = false;
    },
    exportCustomerDialogCloseHandle () {
      this.exportCustomerVisible = false;
    },
    batchDeleteBtn () {
      let checkedData = this.$refs.travellingTraderTable.getCheckboxRecords();
      if (checkedData.length > 0) {
        this.$confirm(this.$t('eventList.Austdtc'), this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          cancelButtonText: this.$t('btn.Cancel'),
          type: 'warning'
        }).then(() => {
          let params = checkedData.map(item => {
            return item.id;
          });
          travellingTrader.customerDelete(params).then(res => {
            if (res.status === '200') {
              this.reloadAfterDelete(checkedData.length);
              this.$message.success(this.$t('general.DeleSucc'));
            }
          });
        }).catch();
      }
    },
    deleteBtn (row) {
      this.$confirm(this.$t('eventList.Austdtsc'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        let params = [row.id];
        travellingTrader.customerDelete(params).then(res => {
          if (res.status === '200') {
            this.reloadAfterDelete(1);
            this.$message.success(this.$t('general.DeleSucc'));
          }
        });
      }).catch();
    },
    upDateCrm () {
      travellingTrader.updateCrm(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          this.$message.success(this.$t('approvalCenter.SyncCRMSuccess'));
          this.loadTable();
        }
      });
    },
    statusChangeBtn (row) {
      let selectRow = this.$refs.travellingTraderTable.getCheckboxRecords();
      if (!row.id && selectRow.length < 1) {
        this.$message.error(this.$t('eventList.Psactc'));
        return;
      }
      let params = {};
      if (!row.id) {
        params.customerStateCode = 0;
        params.idList = selectRow.map(item => {
          return item.id;
        });
      } else {
        params.customerStateCode = row.customerStat ? 0 : 1;
        params.idList = [row.id];
      }
      travellingTrader.customerStateChange(params).then(res => {
        if (res.status === '200') {
          this.loadTable();
          this.$message.success(this.$t('general.ModSucc'));
        }
      });
    },
    editBtn (row) {
      this.rowData = row;
      this.addTraderDialogVisible = true;
    },
    traderCellClassName ({ row, column }) {
      const abnormalFieldMap = {
        name: 'name',
        phone: 'phone',
        email: 'email'
      };
      const field = column.property || column.field;
      const abnormalField = abnormalFieldMap[field];
      if (!abnormalField || !Array.isArray(row.abnormalFields) || !row.abnormalFields.includes(abnormalField)) {
        return '';
      }

      const cellValue = row[field];
      const hasValue = cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '';
      return hasValue ? 'trader-abnormal-cell trader-abnormal-cell-has-value' : 'trader-abnormal-cell';
    },
    getCustomerListParams () {
      const params = {
        activityCode: this.$route.query.activityCode
      };
      if (this.clickStatus) {
        params.showContactAbnormal = true;
      }
      return params;
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('50')
          ._others('checkbox')
          ._fixed('left')
      );
      tableRow.push(
        new TableColumns()
          ._width('150')
          ._title(this.$t('approvalCenter.ActivityNumber'))
          ._data('activityCode')
          ._fixed('left')
      );
      tableRow.push(
        new TableColumns()
          ._width('230')
          ._title(this.$t('newApp.ADList.CustomerUnit'))
          ._data('clientName')
          ._fixed('left')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.isyxq'))
          ._width('120')
          ._data('contactsNeedFlag')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.contactsNeedFlag === '0' ? this.$t('general.no') : row.contactsNeedFlag === '1' ? this.$t('general.yes') : this.$t('newApp.Customers.yyz')}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.khxq'))
          ._width('140')
          ._data('contactsNeed')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.gjjl'))
          ._data('followUpRecord')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.followUpRecord || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('140')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('120')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pbo'))
          // ._data('opportunityName')
          ._data('oppNameList')
          ._width('180')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.oppNameList?.join('，') || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowCustomer')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._width('190')
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
      );
      // 客户联系人
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
      );
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('eventList.Position'))
          ._data('position')
      );
      // 联系电话
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('phone')
      );
      // 邮箱
      tableRow.push(
        new TableColumns()
          ._width('180')
          ._title(this.$t('newApp.ADList.Email'))
          ._data('email')
      );
      tableRow.push(
        new TableColumns()
          ._width('150')
          ._title(this.$t('newApp.BasicInfo.cs'))
          ._data('salerName')
      );
      tableRow.push(
        new TableColumns()
          ._width('150')
          ._title(this.$t('newApp.Customers.khxq') + '（' + this.$t('general.new') + '）')
          ._data('label')
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.ADList.CreationTime'))
          ._data('createTime')
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('newApp.ADList.InviteSourceName'))
          ._data('inviteSourceName')
      );
      // 联系人信息质量
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.ADList.ContactQuality'))
          ._data('qualityTag')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let qualityTag = row.infoComplete === 0 ? (row.qualityTag || '').split('、').filter(Boolean) : ['信息完整'];
              qualityTag = qualityTag.map((item, index) => {
                return {
                  value: item,
                  type: item.includes('错误') ? 'danger' : item.includes('缺失') ? 'warning' : 'info'
                };
              });
              return (
                <div class="quality-content">
                  {qualityTag.map(item => {
                    return <el-tag class="quality-tag" type={item.type}>{item.value}</el-tag>;
                  })}
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('120')
          ._title(this.$t('general.Status'))
          ._data('customerStat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.customerStat ? this.$t('general.Normal') : this.$t('general.Failure')}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width((this.widthAutoFlag ? '285' : this.contactsNeedFlag ? '250' : '150'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              if (row.contactsNeedFlag === '1' && row.columnName === '营销系统客户') {
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.checkBtn(row); }}>{this.$t('newApp.Customers.xqyz')}</el-button>
                    <el-button type="text" onClick={() => { this.addToCrmCommand(row); }}>{row.buttonMark === '0' ? this.$t('btn.Create') : this.$t('btn.Edit')}{this.$t('newApp.Customers.crmkh')}</el-button>
                    <el-button type="text" onClick={() => { this.editBtn(row); }}>{this.$t('btn.Edit')}</el-button>
                    <el-button type="text" onClick={() => { this.statusChangeBtn(row); }}>{row.customerStat ? this.$t('btn.Close') : this.$t('btn.Open')}</el-button>
                    <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                  </div>
                );
              } else if (row.contactsNeedFlag !== '1' && row.columnName === '营销系统客户') {
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.addToCrmCommand(row); }}>{row.buttonMark === '0' ? this.$t('btn.Create') : this.$t('btn.Edit')}{this.$t('newApp.Customers.crmkh')}</el-button>
                    <el-button type="text" onClick={() => { this.editBtn(row); }}>{this.$t('btn.Edit')}</el-button>
                    <el-button type="text" onClick={() => { this.statusChangeBtn(row); }}>{row.customerStat ? this.$t('btn.Close') : this.$t('btn.Open')}</el-button>
                    <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                  </div>
                );
              } else if (row.contactsNeedFlag === '1' && row.columnName !== '营销系统客户') {
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.checkBtn(row); }}>{this.$t('newApp.Customers.xqyz')}</el-button>
                    <el-button type="text" onClick={() => { this.editBtn(row); }}>{this.$t('btn.Edit')}</el-button>
                    <el-button type="text" onClick={() => { this.statusChangeBtn(row); }}>{row.customerStat ? this.$t('btn.Close') : this.$t('btn.Open')}</el-button>
                    <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                  </div>
                );
              } else {
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.editBtn(row); }}>{this.$t('btn.Edit')}</el-button>
                    <el-button type="text" onClick={() => { this.statusChangeBtn(row); }}>{row.customerStat ? this.$t('btn.Close') : this.$t('btn.Open')}</el-button>
                    <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                  </div>
                );
              }
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.travellingTraderTable.setColumn(column);
      const tablePromise = this.$refs.travellingTraderTable.loadTable({ url: '/customer/list', listKey: 'list', params: this.getCustomerListParams() }).then((res) => {

      });

      travellingTrader.getTravellingTraderData({ activityCode: this.$route.query.activityCode, pageNum: 1, pageSize: 99999 }).then(async (res) => {
        // 统计数据
        let statistics = {
          ca: {},
          noocc: 0,
          noucc: 0,
          nolcc: 0,
          noncc: 0,
          nocfuc: 0,
          nolccx: 0,
          nonlcc: 0,
          contactCompletionRate: 0,
          contactExceptionCount: 0,
          tbps: 0
        };
        for (let i of this.statisticsTable) {
          this.$refs.statisticsTable.removeRow(i);
        }

        const pageInfo = res.data.pageInfo || {};
        const tableList = (pageInfo.list || []).filter((item, index, arr) => {
          return arr.findIndex(t => t.clientName === item.clientName) === index;
        });
        const total = Number(pageInfo.total) || 0;
        const contactAbnormalCount = Number(res.data.contactAbnormalCount) || 0;
        statistics.contactExceptionCount = contactAbnormalCount;
        statistics.contactCompletionRate = total > 0 ? ((total - contactAbnormalCount) / total * 100).toFixed(2) + '%' : '0.00%';
        tableList.forEach(item => {
          // 统计数据，拟邀请客户统计
          // 统计start
          let k = item.accountMarked ? (item.accountMarked === '--' ? '空' : item.accountMarked) : '空';
          if (!statistics.ca[k]) {
            statistics.ca[k] = 0;
          }
          statistics.ca[k]++;
          if (item.isOldAccount) {
            // 老客户
            if (item.isOldAccount === '老客户' || item.isOldAccount === '是') {
              statistics.noocc++;
            }
          }
          if (item.columnName) {
            if (item.columnName === '营销系统客户') {
              statistics.noucc++;
            }
            if (item.columnName === '列名客户') {
              statistics.nolcc++;
            }
            if (item.columnName === '非列名客户') {
              statistics.noncc++;
            }
            if (item.columnName === '营销系统渠道') {
              statistics.nocfuc++;
            }
            if (item.columnName === '列名渠道') {
              statistics.nolccx++;
            }
            if (item.columnName === '非列名渠道') {
              statistics.nonlcc++;
            }
          } else {
            statistics.noncc++;
          }
          // 统计end
        });
        // 活动申请列表-参会客户单位-目标业务机会推动个数获取
        const opp = await travellingTrader.getBusOppNum({ activityCode: this.$route.query.activityCode });
        let caContent = [];
        for (let k in statistics.ca) {
          caContent.push(`${k}${this.$t('newApp.ADList.no')}：${statistics.ca[k]}`);
        }

        const statisticsRow = {
          ...statistics,
          ca: caContent.join('，'),
          tbps: opp.data
        };
        this.statisticsTable.push(statisticsRow);
        // this.$refs.statisticsTable.insertRow(statisticsRow)
        this.$refs.statisticsTable.loadStaticTable([statisticsRow]);
      });
      // this.$refs.travellingTraderTable.loadStaticTable();
      // this.$refs.travellingTraderTable.getTableData({ url: '/customer/list', params: { activityCode: this.$route.query.activityCode } }).then(res=>{
      //   console.log(this.$refs.travellingTraderTable.tableData.dataList,res);
      // })
      return tablePromise;
    },
    reloadAfterDelete (deletedCount) {
      const table = this.$refs.travellingTraderTable;
      const currentPage = table.pageData.pageNum;
      const currentPageItemCount = (table.tableData.dataList || []).length;

      // 当前页全部删完且不是第一页，回退到上一页
      if (deletedCount >= currentPageItemCount && currentPage > 1) {
        table.pageData.pageNum = currentPage - 1;
      }

      this.loadTable();
    },
    checkBtn (row) {
      const { id } = row;
      const params = {
        name: row.name,
        clientName: row.clientName,
        needProduct: row.needProduct,
        needChooseName: row.contactsNeed.split('、').join(','),
        needNote: row.needNote,
        industry: row.industry,
        phone: row.phone,
        area: row.area,
        activityCode: row.activityCode
      };
      console.log(row, params);
      this.$store.commit('setSubPageLoading', true);
      travellingTrader.sendCRMLead(params).then(res => {
        console.log(res, 12);
        if (res.status === '200') {
          const params1 = [{ id }];
          travellingTrader.getVerification(params1).then(res => {
            this.$store.commit('setSubPageLoading', false);
            if (res.status === '200') {
              this.loadTable();
            }
          });
        } else if (res.status === '813022') {
          this.$store.commit('setSubPageLoading', false);
          this.$confirm('请点击编辑补全线索必要字段', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$store.commit('setSubPageLoading', false);
        this.$confirm('请点击编辑补全线索必要字段', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        });
      });
    },
    addToCrmCommand (row) {
      if (row.buttonMark === '0') {
        const params = {
          id: row.id
        };
        this.$store.commit('setSubPageLoading', true);
        travellingTrader.addToCrm(params).then(res => {
          this.$store.commit('setSubPageLoading', false);
          if (res.status === '200') {
            this.loadTable();
          }
        });
      } else {
        window.open(row.redirectUrl);
      }
    },
    gethandleTableList (data) {
      let widthAutoFlag = data.some(item => item.contactsNeedFlag === '1' && item.columnName === '营销系统客户');
      if (widthAutoFlag) {
        if (this.widthAutoFlag !== widthAutoFlag) {
          this.widthAutoFlag = widthAutoFlag;
          this.loadTable();
        }
      } else {
        let contactsNeedFlag = data.some(item => item.contactsNeedFlag === '1' || item.columnName === '营销系统客户');
        if (this.contactsNeedFlag !== contactsNeedFlag) {
          this.contactsNeedFlag = contactsNeedFlag;
          this.loadTable();
        }
      }
    },
    loadStatisticsTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.ca'))
          ._data('ca')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noocc'))
          ._data('noocc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noucc'))
          ._data('noucc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolcc'))
          ._data('nolcc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noncc'))
          ._data('noncc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nocfuc'))
          ._data('nocfuc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolccx'))
          ._data('nolccx')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nonlcc'))
          ._data('nonlcc')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.contactCompletionRate'))
          ._headerClassName('statistics-help-header')
          ._titleHelp({
            icon: 'el-icon-question',
            message: this.$t('newApp.inviteCustomer.contactCompletionRateInfo')
          })
          ._data('contactCompletionRate')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.contactExceptionCount'))
          ._headerClassName('statistics-help-header')
          ._titleHelp({
            icon: 'el-icon-question',
            message: this.$t('newApp.inviteCustomer.contactExceptionCountInfo')
          })
          ._data('contactExceptionCount')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return row.contactExceptionCount ? (
                <div
                  class="contact-exception-count"
                  onClick={() => this.handleContactExceptionClick()}
                >
                  <div class={this.clickStatus ? 'contact-exception-count-active' : ''}>
                    {row.contactExceptionCount}
                  </div>
                  <div class="contact-exception-count-text">
                    {this.$t('general.ctView')}
                  </div>
                </div>
              ) : row.contactExceptionCount;
            }
          })
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.tbps'))
          ._data('tbps')
      );

      let column = tableRow._cols();
      this.$refs.statisticsTable.setColumn(column, {
        page: false
      });
    },
    handleContactExceptionClick () {
      this.clickStatus = !this.clickStatus;
      this.$refs.travellingTraderTable.pageData.pageNum = 1;
      this.loadTable();
    },
    addtatisticsTable () {
      // 测试添加数据
      // this.$refs.statisticsTable.insertRow({
      //   ca: "a:1 b:2",
      //   noocc: "a:1 b:2",
      //   noucc: "a:1 b:2",
      //   nolcc: "a:1 b:2",
      //   noncc: "a:1 b:2",
      //   nocfuc: "a:1 b:2",
      //   nolccx: "a:1 b:2",
      //   nonlcc: "a:1 b:2",
      // })
    }
  },
  mounted () {
    this.loadStatisticsTable();
    this.loadTable();
    // 表格回显字段处理
    this.dataFilterMethod = (list) => {
      return list.map(item => {
        let isOldAccount = '--';
        // 当年是否产出字段处理：如果有值则是， 客户身份如果是客户，则值为'--'
        let output = item.output;
        const oldAccountList = [this.$t('general.yes'), this.$t('general.Ocus')];
        const filterList = [null, undefined, 'undefined'];
        if (item.isChannel !== this.$t('general.OperChannelation')) {
          // 客户类别明细字段处理
          if (!filterList.includes(item.isOldAccount)) {
            isOldAccount = oldAccountList.includes(item.isOldAccount) ? this.$t('general.Ocus') : this.$t('general.Ncus');
          } else {
            if (item.columnName === '营销系统客户') {
              isOldAccount = '--';
            } else {
              isOldAccount = this.$t('general.Ncus');
            }
          }
          output = '--';
        }

        return {
          ...item,
          industry: item.industry === 'null' ? '' : item.industry,
          province: item.province === 'null' ? '' : item.province,
          city: item.city === 'null' ? '' : item.city,
          output,
          isOldAccount
        };
      });
    };
  }

};
</script>

<style lang="scss" scoped>
.travellingTrader {
  .buttonBar {
    >.custom {
      margin-right: 20px;
      color: #14937B;

      >span {
        cursor: pointer;

        >img {
          vertical-align: middle;
        }

        >span {
          vertical-align: middle;
          margin-left: 6px;
        }

        &+span {
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }

  ::v-deep .trader-abnormal-cell {
    background-color: #fff1f2 !important;
  }

  ::v-deep .trader-abnormal-cell.trader-abnormal-cell-has-value .vxe-cell {
    color: #f05f6d;
  }

  ::v-deep .statistics-help-header .vxe-cell {
    display: inline-flex;
    align-items: center;
  }

  ::v-deep .statistics-help-header .vxe-cell--title {
    order: 1;
  }

  ::v-deep .statistics-help-header .vxe-cell-help-icon {
    order: 2;
    margin-left: 4px;
    margin-right: 0;
    color: #c0c4cc;
    font-size: 14px;
  }
}
.quality-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;

  ::v-deep .quality-tag {
    height: 22px;
    padding: 0 9px;
    line-height: 20px;
    font-size: 12px;
    border-radius: 12px;
    background-color: #eaf8f1;
    border-color: #bfe9d5;
    color: #3bb37f;
  }

  ::v-deep .quality-tag.el-tag--danger {
    background-color: #fff0f1;
    border-color: #ffc4ca;
    color: #f06a78;
  }

  ::v-deep .quality-tag.el-tag--warning {
    background-color: #fff7e8;
    border-color: #ffd99b;
    color: #f2a73a;
  }
}
.contact-exception-count{
  color: #3bb37f;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.contact-exception-count-active{
  font-weight: bold;
}
.contact-exception-count-text{
  text-decoration: underline;
}
</style>
